import { env } from '../Env';
import { jsPDF } from "jspdf";
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import { rqx } from '../request/API';

export const uploadToS3Presigned = async (file, params) => { 
    const { requestRef, feature_ref, tool_id, privacy = 'private' } = params 
 
    const body = { 
        rqxRef: requestRef, 
        file_name: file[0].name, 
        file_type: file[0].type, 
        size: file[0].size, 
        feature_ref, 
        tool_id, 
        env: env(), 
        privacy 
    } 
 
    const rqxPreSigned = await rqx.post(`<<s3>>/${env()}/glbl/transmit/uploadRqx`, body) 
 
    const { uploadUrl } = rqxPreSigned 
 
    const uploadResponse = await fetch(uploadUrl, { 
        method: 'PUT', 
        headers: { 
            'Content-Type': file[0].type 
        }, 
        body: file[0] 
    }) 
 
    return { rqxPreSigned, uploadResponse } 
} 

export const Download = (e, links, name) => {
    return new Promise(resolve => {
        fetch(links, {method: 'GET', headers: { "Cache-Control": 'no-cache' } })
        .then(res => {
            return res.blob();
        })
        .then(blob => {
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = name;
            document.body.appendChild(a);
            a.click();  
            setTimeout(
            _ => { window.URL.revokeObjectURL(url); },
            60000);
            a.remove();
            return resolve('success')
        })
        .catch(err => {
            console.error('err: ', err);
            return resolve('error')
        })
    }).catch(err => {
        console.error('err: ', err);
        return 'error'
    })
}

export const DownloadPDF = (link, name) => {
    const doc = new jsPDF();
    doc.addImage(link, name.split('.')[1], 15, 40, 180, 180);
    doc.save(name.split('.')[0] + '.pdf');
    return 'success'
}

export const DownloadZip = async(data) => {
    const zip = new JSZip();

    for (let i = 0; i < data.length; i++) {
        var mainFolder = data[0].folder_name
        if (data[i].parent_id === 0) {
            mainFolder = zip.folder(data[i].folder_name);
            // eslint-disable-next-line 
            const addFileToZip = async (file) => {
                try {
                    const content = await JSZipUtils.getBinaryContent(file.link);
                    mainFolder.file(file.name, content, { binary: true });
                } catch (error) {
                    console.error(`Error downloading file ${file.name} from ${file.link}:`, error);
                }
            };
    
            await Promise.all(JSON.parse(data[i].files).map(addFileToZip))
        }
        else{
            for (let j = 0; j < data.length; j++) {
                const subFolders = zip.folder(mainFolder);
                let subFolder = data[i].folder_name
                if (data[i].parent_id === data[j].id) {
                    if (data[j].parent_id === 0) {
                        subFolder = subFolders.folder(data[i].folder_name);
                    }else{
                        subFolder = subFolders.folder(data[j].folder_name + '/' + data[i].folder_name);
                    }
                    // eslint-disable-next-line 
                    const addFileToZip = async (file) => {
                        try {
                            const content = await JSZipUtils.getBinaryContent(file.link);
                            subFolder.file(file.name, content, { binary: true });
                        } catch (error) {
                            console.error(`Error downloading file ${file.name} from ${file.link}:`, error);
                        }
                    };
                    await Promise.all(JSON.parse(data[i].files).map(addFileToZip))
                    break;
                }
            }
        }
    }

    const zipBlob = await zip.generateAsync({ type: 'blob' });

    saveAs(zipBlob, `${data[0].folder_name}.zip`);
    return 'success'
}
